import { brandApi } from "@/lib/axios";

export interface OmnisendStatus {
  connected: boolean;
  status: "ACTIVE" | "NEEDS_RECONNECT" | "DISCONNECTED" | null;
  accountId: string | null;
  accountName: string | null;
}

export async function getOmnisendStatus(): Promise<OmnisendStatus> {
  const { data } = await brandApi.get<OmnisendStatus>("/omnisend/status");
  return data;
}

/** The Omnisend install URL; send the browser there to start connecting. */
export async function getOmnisendOauthUrl(): Promise<{ url: string }> {
  const { data } = await brandApi.get<{ url: string }>("/omnisend/oauth/url");
  return data;
}

export async function disconnectOmnisend(): Promise<{ disconnected: boolean }> {
  const { data } = await brandApi.delete<{ disconnected: boolean }>("/omnisend/connection");
  return data;
}
